
export const ALPHANUMERIC_REGEX = /[^a-z0-9]/gim;

export const NUMERIC_REGEX = /[^0-9]/gim;
